import React, { useRef, useState } from 'react';
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Form, Button, message, Row } from 'antd';
import { cerrarPreNomina } from '../../../../apis/ProcesoPreNominaApi';
import AnioPreNomina from '../../../../components/forms/anio_prenomina';
import { status_prenomina } from '../../../../constants/prenomina';

const routes = [
  {
    href: '',
    title: (
      <>
        <HomeOutlined />
        <span>Inicio</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Asistencia</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Procesos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Cierre</span>
      </>
    ),
  },
];

const CierrePreNomina = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [objectSelected, setObjectSelected] = useState(null);
  const [status, setStatus] = useState(null);
  const anioPrenominaRef = useRef(null);

  const handleOk = async () => {
    setLoading(true);
    try {
      const fields = form.getFieldsValue();
      const payload = {
        periodo_id: fields.periodo_id,
        anio: fields.anio,
        num_periodo: fields.num_periodo,
      };

      const response = await cerrarPreNomina(payload);
      if (response.ok) {
        message.success('Se cerro correctamente la pre-nomina');
        await anioPrenominaRef.current?.refreshStatus?.();
      }
    } finally {
      setLoading(false);
    }
  };

  const onBlurHeader = async (values, dataPeriod, currentStatus) => {
    setStatus(currentStatus?.value);
  };

  return (
    <PageApp routes={routes} title={'Cierre de Pre-Nomina'}>
      <AnioPreNomina
        ref={anioPrenominaRef}
        onBlur={onBlurHeader}
        form={form}
        disabledForm={objectSelected && objectSelected.id > 0}
      />
      <Row className="mt-4 mb-4">
        <Button
          type="primary"
          onClick={handleOk}
          loading={loading}
          disabled={status !== status_prenomina.total}
        >
          {loading ? 'Procesando' : 'Cerrar Pre-Nomina'}
        </Button>
      </Row>
    </PageApp>
  );
};

export default CierrePreNomina;
